document.documentElement.classList.remove('no-js');
const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
$$('[data-mobile-toggle]').forEach(b=>b.addEventListener('click',()=>$('.mobile-menu')?.classList.toggle('open')));
const drawer=$('[data-cart-drawer]'), backdrop=$('.drawer-backdrop');
function drawerState(open){drawer?.classList.toggle('open',open);backdrop?.classList.toggle('open',open);drawer?.setAttribute('aria-hidden',String(!open));}
$$('[data-cart-open]').forEach(b=>b.addEventListener('click',()=>drawerState(true)));$$('[data-drawer-close]').forEach(b=>b.addEventListener('click',()=>drawerState(false)));
$$('[data-product-root]').forEach(root=>{
  const variants=JSON.parse($('[data-variants-json]',root)?.textContent||'[]');
  const select=$('select[name="id"]',root), price=$('[data-product-price]',root), button=$('[name="add"]',root), groups=$$('[data-option-index]',root);
  const formatPrice=p=>(p/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'GBP'});
  const setPillsFromVariant=v=>groups.forEach((g,i)=>{$$('.option-pill',g).forEach(p=>p.classList.toggle('active',p.dataset.value===v.options[i]))});
  const chosenOptions=()=>groups.map(g=>$('.option-pill.active',g)?.dataset.value);
  const findVariant=()=>variants.find(v=>v.options.every((o,i)=>o===chosenOptions()[i]));

  // Only show downstream option values that actually belong to the options already selected above them.
  // Example: Vehicle = Audi S3 will only render S3 generations, rather than A3/RS3 generations as disabled pills.
  const updateOptionVisibility=()=>{
    const chosen=chosenOptions();
    groups.forEach((group,index)=>{
      const prior=chosen.slice(0,index);
      const pills=$$('.option-pill',group);
      pills.forEach(pill=>{
        const value=pill.dataset.value;
        const exists=variants.some(v=>v.options[index]===value && prior.every((o,i)=>!o || v.options[i]===o));
        pill.hidden=!exists;
        pill.classList.toggle('is-hidden-fitment',!exists);
        if(!exists) pill.classList.remove('active');
      });

      // If the active value became invalid after a parent option changed, select the first valid value.
      if(index>0 && !$('.option-pill.active:not([hidden])',group)){
        const first=pills.find(p=>!p.hidden);
        if(first) first.classList.add('active');
      }
      chosen[index]=$('.option-pill.active:not([hidden])',group)?.dataset.value;
    });
  };

  const updateAvailability=()=>{
    updateOptionVisibility();
    const chosen=chosenOptions();
    groups.forEach((group,index)=>{$$('.option-pill',group).forEach(pill=>{
      if(pill.hidden){pill.disabled=true;return;}
      const trial=[...chosen]; trial[index]=pill.dataset.value;
      // A pill stays selectable if at least one available variant can be reached while respecting all earlier choices.
      const possible=variants.some(v=>v.available && v.options[index]===pill.dataset.value && trial.slice(0,index).every((o,i)=>!o || v.options[i]===o));
      pill.classList.toggle('is-unavailable',!possible); pill.disabled=!possible;
    })});
  };

  const resolveVariant=(changedIndex=0)=>{
    updateOptionVisibility();
    let chosen=chosenOptions();
    let exact=variants.find(v=>v.available && v.options.every((o,i)=>o===chosen[i]));
    if(exact) return exact;

    // Pick the first available variant matching all choices up to the option the customer just changed.
    const fallback=variants.find(v=>v.available && v.options.slice(0,changedIndex+1).every((o,i)=>o===chosen[i]));
    if(fallback){setPillsFromVariant(fallback);updateOptionVisibility();return fallback;}

    // Last resort: keep the first available variant so the form never gets stranded on "Choose your fitment".
    const any=variants.find(v=>v.available)||variants[0];
    if(any){setPillsFromVariant(any);updateOptionVisibility();}
    return any;
  };

  const render=v=>{
    if(v&&select){
      select.value=v.id;
      if(price)price.textContent=formatPrice(v.price);
      root.querySelectorAll('[data-sticky-price]').forEach(x=>x.textContent=formatPrice(v.price));
      button.disabled=!v.available;
      button.textContent=v.available?'Add to cart':'Sold out';
      history.replaceState({},'',`${location.pathname}?variant=${v.id}${location.hash}`);
    } else if(button){button.disabled=true;button.textContent='Choose your fitment'}
    updateAvailability();
  };

  let initial=variants.find(v=>String(v.id)===new URLSearchParams(location.search).get('variant')&&v.available)||variants.find(v=>v.available)||variants[0];
  if(initial){setPillsFromVariant(initial);updateOptionVisibility();render(initial)}

  groups.forEach((g,index)=>$$('.option-pill',g).forEach(p=>p.addEventListener('click',()=>{
    if(p.disabled||p.hidden)return;
    $$('.option-pill',g).forEach(x=>x.classList.remove('active'));
    p.classList.add('active');

    // Changing an earlier fitment choice resets downstream values to the first valid path.
    for(let i=index+1;i<groups.length;i++){
      $$('.option-pill',groups[i]).forEach(x=>x.classList.remove('active'));
    }
    updateOptionVisibility();
    const v=resolveVariant(index);
    if(v)setPillsFromVariant(v);
    render(v||findVariant());
  })));
});
$$('[data-ajax-product-form]').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();const btn=$('[name="add"]',form);if(btn?.disabled)return;btn.textContent='Adding…';try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});if(!r.ok)throw new Error();drawerState(true);const c=await fetch('/cart.js').then(x=>x.json());$('[data-cart-count]')?.replaceChildren(document.createTextNode(c.item_count));document.dispatchEvent(new CustomEvent('sette:cart-updated'));$('[data-cart-drawer-content]').innerHTML=`<p><strong>${c.item_count} item${c.item_count===1?'':'s'}</strong> added to your build.</p><p class="muted">Subtotal: ${(c.total_price/100).toLocaleString(undefined,{style:'currency',currency:c.currency})}</p>`;}catch(err){alert('Could not add this item. Please try again.');}finally{btn.textContent='Add to cart';}}));
// Reveal desktop navigation when the user scrolls upward; hide it while scrolling down.
(() => {
  const header = document.querySelector('[data-smart-header]');
  if (!header) return;
  let lastY = window.scrollY;
  let ticking = false;
  let hideTimer;

  const reveal = () => {
    clearTimeout(hideTimer);
    header.classList.add('nav-revealed');
  };

  const hide = () => {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => header.classList.remove('nav-revealed'), 120);
  };

  const updateHeader = () => {
    const currentY = window.scrollY;
    const delta = currentY - lastY;

    if (window.innerWidth > 950) {
      if (currentY < 20) {
        header.classList.remove('nav-revealed');
      } else if (delta < -8) {
        reveal();
      } else if (delta > 10) {
        hide();
      }
    }

    lastY = currentY;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
})();


// SETTE MOTION v4: loader, page transitions, reveals, parallax and reactive lighting.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const loader = document.querySelector('[data-sette-loader]');
  const hideLoader = () => loader?.classList.add('is-hidden');
  if (document.readyState === 'complete') setTimeout(hideLoader, 180);
  else window.addEventListener('load', () => setTimeout(hideLoader, 260), { once: true });
  setTimeout(hideLoader, 2200);

  if (!reduceMotion) {
    document.querySelectorAll('a[href]').forEach(link => {
      link.addEventListener('click', event => {
        const url = new URL(link.href, location.href);
        const sameOrigin = url.origin === location.origin;
        const normalClick = !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && link.target !== '_blank';
        if (!sameOrigin || !normalClick || url.hash || link.hasAttribute('download') || link.dataset.cartOpen !== undefined) return;
        event.preventDefault();
        document.body.classList.add('sette-page-exit');
        setTimeout(() => location.href = url.href, 260);
      });
    });
  }

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12, rootMargin: '0px 0px -7% 0px' });
    revealItems.forEach(item => observer.observe(item));
  } else revealItems.forEach(item => item.classList.add('is-revealed'));

  const parallaxRoots = [...document.querySelectorAll('[data-parallax-root]')];
  let parallaxTicking = false;
  const parallaxUpdate = () => {
    const vh = window.innerHeight;
    parallaxRoots.forEach(root => {
      const rect = root.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      const progress = (vh - rect.top) / (vh + rect.height);
      const media = root.querySelector('[data-parallax-media]');
      const content = root.querySelector('[data-reveal-content]');
      media?.style.setProperty('--parallax-y', `${(progress - .5) * 46}px`);
      content?.style.setProperty('--hero-content-y', `${(progress - .5) * -22}px`);
    });
    parallaxTicking = false;
  };
  if (!reduceMotion) window.addEventListener('scroll', () => {
    if (!parallaxTicking) { requestAnimationFrame(parallaxUpdate); parallaxTicking = true; }
  }, { passive: true });
  parallaxUpdate();

  if (window.matchMedia('(hover:hover)').matches && !reduceMotion) {
    document.querySelectorAll('[data-reactive-card]').forEach(card => {
      card.addEventListener('pointermove', e => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left, y = e.clientY - rect.top;
        const px = x / rect.width, py = y / rect.height;
        card.style.setProperty('--mx', `${px * 100}%`);
        card.style.setProperty('--my', `${py * 100}%`);
        card.style.setProperty('--ry', `${(px - .5) * 5}deg`);
        card.style.setProperty('--rx', `${(.5 - py) * 4}deg`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--mx', '50%');
        card.style.setProperty('--my', '50%');
      });
    });
  }
})();

// SETTE v4.3: reliably start cinematic hero videos, including inside Shopify theme editor.
(() => {
  const startHeroVideos = (root = document) => {
    root.querySelectorAll?.('[data-hero-video]').forEach(video => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      const attempt = () => {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      };
      if (video.readyState >= 2) attempt();
      else {
        video.addEventListener('loadeddata', attempt, { once: true });
        video.addEventListener('canplay', attempt, { once: true });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => startHeroVideos());
  else startHeroVideos();
  window.addEventListener('load', () => startHeroVideos());
  document.addEventListener('shopify:section:load', event => startHeroVideos(event.target));
  document.addEventListener('shopify:section:select', event => startHeroVideos(event.target));
})();

// SETTE v5: make newly selected images/videos visible immediately in the Shopify editor.
(() => {
  const activateMedia = (root = document) => {
    root.querySelectorAll?.('video').forEach(video => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      if (video.hasAttribute('autoplay')) {
        const play = () => video.play().catch(() => {});
        if (video.readyState >= 2) play();
        else video.addEventListener('canplay', play, { once:true });
      }
    });
    root.querySelectorAll?.('[data-reveal]').forEach(el => el.classList.add('is-revealed'));
  };
  document.addEventListener('shopify:section:load', e => activateMedia(e.target));
  document.addEventListener('shopify:section:select', e => activateMedia(e.target));
  document.addEventListener('shopify:block:select', e => activateMedia(e.target));
  if (document.documentElement.classList.contains('shopify-design-mode') || window.Shopify?.designMode) activateMedia();
})();


// SETTE v6 launch commerce utilities
(() => {
  const money = (p,c='GBP') => (p/100).toLocaleString(undefined,{style:'currency',currency:c});
  const wishlistKey='sette_saved_build';
  const getSaved=()=>{try{return JSON.parse(localStorage.getItem(wishlistKey)||'[]')}catch{return[]}};
  const setSaved=x=>localStorage.setItem(wishlistKey,JSON.stringify(x));
  document.querySelectorAll('[data-wishlist]').forEach(btn=>{
    const id=String(btn.dataset.productId), refresh=()=>{const on=getSaved().some(x=>String(x.id)===id);btn.classList.toggle('active',on);btn.textContent=on?'Saved to build':'Save to build'};
    btn.addEventListener('click',()=>{let list=getSaved();const i=list.findIndex(x=>String(x.id)===id);if(i>=0)list.splice(i,1);else list.push({id,title:btn.dataset.productTitle,url:location.pathname});setSaved(list);refresh()});refresh();
  });
  document.querySelectorAll('[data-vehicle-selector]').forEach(form=>form.addEventListener('submit',e=>{e.preventDefault();const d=new FormData(form);const q=[d.get('make'),d.get('model'),d.get('generation'),d.get('year'),d.get('body')].filter(Boolean).join(' ');if(q)location.href=`/search?q=${encodeURIComponent(q)}&type=product`}));
  async function renderCart(){
    const c=await fetch('/cart.js').then(r=>r.json());
    document.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=c.item_count);
    const host=document.querySelector('[data-cart-drawer-content]'); if(!host)return;
    if(!c.items.length){host.innerHTML='<div class="empty-drawer"><p>Your garage is empty.</p><a class="btn btn-primary" href="/collections/all">Explore catalog</a></div>'}
    else host.innerHTML=c.items.map(i=>`<div class="drawer-item"><img src="${i.image||''}" alt=""><div><strong>${i.product_title}</strong><small>${i.variant_title||''}</small><span>${money(i.final_line_price,c.currency)}</span></div><button data-remove-line="${i.key}" aria-label="Remove">×</button></div>`).join('')+`<div class="drawer-subtotal"><span>Subtotal</span><strong>${money(c.total_price,c.currency)}</strong></div>`;
    const target=10000, remaining=Math.max(0,target-c.total_price), pct=Math.min(100,c.total_price/target*100);document.querySelector('[data-shipping-bar]')?.style.setProperty('width',pct+'%');const msg=document.querySelector('[data-shipping-message]');if(msg)msg.textContent=remaining?`${money(remaining,c.currency)} away from free UK delivery`:'Free UK delivery unlocked';
    host.querySelectorAll('[data-remove-line]').forEach(b=>b.addEventListener('click',async()=>{await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.dataset.removeLine,quantity:0})});renderCart()}));
  }
  document.querySelectorAll('[data-cart-open]').forEach(b=>b.addEventListener('click',renderCart));
  document.addEventListener('sette:cart-updated',renderCart); renderCart();
})();


// SETTE v8: garage persistence, fitment confidence, richer saved builds, recently viewed and mobile sticky cart.
(() => {
  const vehicleKey='sette_vehicle';
  const savedKey='sette_saved_build';
  const recentKey='sette_recently_viewed';
  const read=(key,fallback)=>{try{return JSON.parse(localStorage.getItem(key)||JSON.stringify(fallback))}catch{return fallback}};
  const write=(key,value)=>localStorage.setItem(key,JSON.stringify(value));
  const normalise=v=>(v||'').toString().trim().toLowerCase().replace(/[–—]/g,'-');
  const vehicleLabel=v=>[v?.year,v?.make,v?.model,v?.generation,v?.body].filter(Boolean).join(' ');

  function savedVehicle(){return read(vehicleKey,null)}
  function syncVehicleUI(){
    const v=savedVehicle();
    document.querySelectorAll('[data-vehicle-selector]').forEach(form=>{
      if(v){
        ['make','model','generation','year','body'].forEach(k=>{const el=form.elements[k];if(el&&!el.value)el.value=v[k]||''});
      }
    });
    document.querySelectorAll('[data-saved-car]').forEach(box=>{
      if(v&&v.make){box.hidden=false;const label=box.querySelector('[data-saved-car-label]');if(label)label.textContent=vehicleLabel(v)}else box.hidden=true;
    });
    document.querySelectorAll('[data-product-fitment-saved]').forEach(box=>{
      if(!v?.make){box.hidden=true;return}
      box.hidden=false;box.textContent=`Saved: ${vehicleLabel(v)}`;
    });
    updateFitmentConfidence();
  }
  function matchCard(card,v){
    if(!v?.make)return null;
    const rawTags=(card.dataset.productTags||'').split('|').map(normalise).filter(Boolean);
    const hay=normalise(`${card.dataset.productTitle||''} ${card.dataset.productTags||''}`);
    const make=normalise(v.make), model=normalise(v.model), gen=normalise(v.generation), year=normalise(v.year);

    // v8.5 compatibility bypasses:
    // "Universal" = compatible with every saved vehicle.
    // "Audi Universal" = compatible with every Audi, regardless of model/generation/body style.
    if(rawTags.includes('universal')) return true;
    if(make==='audi' && rawTags.includes('audi universal')) return true;

    if(make && !hay.includes(make)) return false;
    if(model && !hay.includes(model)) return false;
    if(gen && !hay.includes(gen)) return null;
    if(year && !hay.includes(year)) return null;
    return true;
  }
  function updateFitmentConfidence(){
    const v=savedVehicle();
    document.querySelectorAll('[data-product-card]').forEach(card=>{
      const badge=card.querySelector('[data-fitment-confidence]');if(!badge)return;
      if(!v?.make){badge.hidden=true;return}
      const state=matchCard(card,v);badge.hidden=false;
      badge.classList.toggle('fitment-confidence--yes',state===true);
      badge.classList.toggle('fitment-confidence--no',state===false);
      badge.textContent=state===true?'Fits your car ✓':state===false?'Different vehicle':'Check fitment';
    });
  }
  document.querySelectorAll('[data-vehicle-selector]').forEach(form=>{
    form.addEventListener('submit',e=>{
      e.preventDefault();const d=new FormData(form);const v={make:d.get('make')||'',model:d.get('model')||'',generation:d.get('generation')||'',year:d.get('year')||'',body:d.get('body')||''};
      write(vehicleKey,v);syncVehicleUI();
      const q=[v.make,v.model,v.generation,v.year,v.body].filter(Boolean).join(' ');if(q)location.href=`/search?q=${encodeURIComponent(q)}&type=product`;
    });
  });
  document.querySelectorAll('[data-clear-car]').forEach(b=>b.addEventListener('click',()=>{localStorage.removeItem(vehicleKey);document.querySelectorAll('[data-vehicle-selector]').forEach(f=>f.reset());syncVehicleUI()}));
  syncVehicleUI();

  const categoryFor=item=>{
    const h=normalise(`${item.type||''} ${item.title||''} ${item.tags||''}`);
    if(/splitter|diffuser|spoiler|skirt|grille|canard|mirror|body|aero|exterior/.test(h))return'exterior';
    if(/steering|paddle|trim|seat|mat|ambient|interior/.test(h))return'interior';
    if(/intake|exhaust|suspension|brake|turbo|intercooler|performance|engine|tune/.test(h))return'performance';
    if(/carplay|dashcam|light|charger|technology|tech|screen|audio/.test(h))return'technology';
    return'exterior';
  };
  function updateProgress(){
    const list=read(savedKey,[]), counts={exterior:0,interior:0,performance:0,technology:0};
    list.forEach(i=>counts[categoryFor(i)]++);
    document.querySelectorAll('[data-build-count]').forEach(el=>el.textContent=counts[el.dataset.buildCount]||0);
  }
  // Upgrade existing save buttons with richer product data while preserving old saved entries.
  document.querySelectorAll('[data-wishlist]').forEach(btn=>{
    const old=btn.onclick; // listener from v6 remains; we enrich on click after it fires.
    btn.addEventListener('click',()=>setTimeout(()=>{
      let list=read(savedKey,[]),id=String(btn.dataset.productId),i=list.findIndex(x=>String(x.id)===id);
      if(i>=0){list[i]={...list[i],id,title:btn.dataset.productTitle,type:btn.dataset.productType,price:Number(btn.dataset.productPrice||0),url:btn.dataset.productUrl||location.pathname,image:btn.dataset.productImage||'',tags:btn.dataset.productTags||''};write(savedKey,list)}
      updateProgress();
    },0));
  });
  updateProgress();

  const viewed=document.querySelector('[data-viewed-product]');
  if(viewed){
    const current={id:viewed.dataset.productId,title:viewed.dataset.productTitle,url:viewed.dataset.productUrl,image:viewed.dataset.productImage||'',price:Number(viewed.dataset.productPrice||0),type:viewed.dataset.productType||'',tags:viewed.dataset.productTags||''};
    let recent=read(recentKey,[]).filter(x=>String(x.id)!==String(current.id));recent.unshift(current);recent=recent.slice(0,8);write(recentKey,recent);
    const others=recent.filter(x=>String(x.id)!==String(current.id)).slice(0,4),host=document.querySelector('[data-recently-viewed]'),section=document.querySelector('[data-recently-viewed-section]');
    if(host&&others.length){host.innerHTML=others.map(x=>`<article class="product-card"><a href="${x.url}"><div class="product-card-media">${x.image?`<img src="${x.image}" loading="lazy" alt="">`:''}</div><div class="product-card-copy"><div class="product-card-title">${x.title}</div><div class="price">${(x.price/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'GBP'})}</div></div></a></article>`).join('');section.hidden=false;}
  }

  const sticky=document.querySelector('[data-sticky-atc]'), mainForm=document.querySelector('[data-ajax-product-form]');
  if(sticky&&mainForm){
    const stickyBtn=sticky.querySelector('[data-sticky-add]');
    stickyBtn?.addEventListener('click',()=>mainForm.requestSubmit(mainForm.querySelector('[name="add"]')));
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>sticky.classList.toggle('is-visible',!entry.isIntersecting))},{threshold:.1});observer.observe(mainForm);
    const mainBtn=mainForm.querySelector('[name="add"]');
    const sync=()=>{if(stickyBtn&&mainBtn){stickyBtn.disabled=mainBtn.disabled;stickyBtn.textContent=mainBtn.textContent}};
    new MutationObserver(sync).observe(mainBtn,{attributes:true,childList:true,subtree:true});sync();
  }
})();

// SETTE v8.1: visible garage + complete Your Build experience.
(() => {
  const vehicleKey='sette_vehicle', savedKey='sette_saved_build';
  const read=(k,f)=>{try{return JSON.parse(localStorage.getItem(k)||JSON.stringify(f))}catch{return f}};
  const write=(k,v)=>localStorage.setItem(k,JSON.stringify(v));
  const money=p=>(Number(p||0)/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'GBP'});
  const vehicleLabel=v=>[v?.year,v?.make,v?.model,v?.generation,v?.body].filter(Boolean).join(' ');
  const esc=s=>String(s||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  const normalise=v=>(v||'').toString().toLowerCase();
  const categoryFor=item=>{const h=normalise(`${item.type||''} ${item.title||''} ${item.tags||''}`);if(/splitter|diffuser|spoiler|wing|skirt|grille|canard|spat|badge|exterior/.test(h))return'exterior';if(/steering|paddle|trim|seat|cushion|mat|ambient|interior/.test(h))return'interior';if(/intake|exhaust|suspension|brake|turbo|intercooler|performance|engine|tune/.test(h))return'performance';if(/carplay|dashcam|charger|technology|tech|screen|audio|lighting/.test(h))return'technology';return'exterior'};
  const counts=()=>{const c={exterior:0,interior:0,performance:0,technology:0};read(savedKey,[]).forEach(x=>c[categoryFor(x)]++);return c};

  const panel=document.querySelector('[data-garage-panel]'), backdrop=document.querySelector('[data-sette-panel-backdrop]');
  const form=panel?.querySelector('[data-garage-form]'), current=panel?.querySelector('[data-garage-current]');
  function syncHeader(){
    const v=read(vehicleKey,null), list=read(savedKey,[]);
    document.querySelectorAll('[data-build-total]').forEach(x=>x.textContent=list.length);
    document.querySelectorAll('[data-garage-build-count]').forEach(x=>x.textContent=list.length);
    document.querySelectorAll('[data-garage-dot]').forEach(x=>x.hidden=!v?.make);
    document.querySelectorAll('[data-garage-label],[data-build-car-label]').forEach(x=>x.textContent=v?.make?vehicleLabel(v):'No car selected');
    if(current){current.hidden=!v?.make;form.hidden=!!v?.make}
    if(form&&v){['make','model','generation','year','body'].forEach(k=>{if(form.elements[k])form.elements[k].value=v[k]||''})}
  }
  function openPanel(){if(!panel)return;panel.classList.add('is-open');panel.setAttribute('aria-hidden','false');if(backdrop)backdrop.hidden=false;document.body.classList.add('panel-open');syncHeader()}
  function closePanel(){if(!panel)return;panel.classList.remove('is-open');panel.setAttribute('aria-hidden','true');if(backdrop)backdrop.hidden=true;document.body.classList.remove('panel-open')}
  document.addEventListener('click',e=>{if(e.target.closest('[data-garage-open]')){e.preventDefault();openPanel()}if(e.target.closest('[data-garage-close]'))closePanel();if(e.target===backdrop)closePanel();const ch=e.target.closest('[data-garage-change]');if(ch&&form){current.hidden=true;form.hidden=false;form.elements.make?.focus()}});
  form?.addEventListener('submit',e=>{e.preventDefault();const d=new FormData(form),v={make:d.get('make')||'',model:d.get('model')||'',generation:d.get('generation')||'',year:d.get('year')||'',body:d.get('body')||''};write(vehicleKey,v);syncHeader();document.dispatchEvent(new CustomEvent('sette:vehicle-updated',{detail:v}));});

  function enrichSaveButton(btn){
    const id=String(btn.dataset.productId), list=read(savedKey,[]), i=list.findIndex(x=>String(x.id)===id);
    if(i>=0){list[i]={...list[i],id,title:btn.dataset.productTitle,type:btn.dataset.productType,price:Number(btn.dataset.productPrice||0),url:btn.dataset.productUrl||location.pathname,image:btn.dataset.productImage||'',tags:btn.dataset.productTags||''};write(savedKey,list)}
  }
  document.querySelectorAll('[data-wishlist]').forEach(btn=>btn.addEventListener('click',()=>setTimeout(()=>{
    enrichSaveButton(btn);syncHeader();
    if(btn.classList.contains('active')){
      let toast=document.querySelector('[data-build-toast]');if(!toast){toast=document.createElement('div');toast.className='build-toast';toast.dataset.buildToast='';document.body.appendChild(toast)}
      toast.innerHTML=`<strong>Added to your build ✓</strong><span>${esc(btn.dataset.productTitle)}</span><a href="/pages/your-build">View your build →</a>`;toast.classList.add('show');clearTimeout(window.__setteBuildToast);window.__setteBuildToast=setTimeout(()=>toast.classList.remove('show'),4200);
    }
  },30)));

  function renderBuild(){
    const host=document.querySelector('[data-build-items]');if(!host)return;
    const list=read(savedKey,[]), empty=document.querySelector('[data-build-empty]'), next=document.querySelector('[data-build-next]'), c=counts();
    document.querySelector('[data-build-total-label]').textContent=`${list.length} part${list.length===1?'':'s'} saved`;
    ['exterior','interior','performance','technology'].forEach(k=>{document.querySelectorAll(`[data-build-page-count="${k}"]`).forEach(x=>x.textContent=c[k]);document.querySelectorAll(`[data-build-page-bar="${k}"]`).forEach(x=>x.style.width=`${Math.min(100,c[k]*20)}%`)});
    if(!list.length){host.innerHTML='';empty.hidden=false;if(next)next.hidden=true;return}empty.hidden=true;if(next)next.hidden=false;
    host.innerHTML=list.map(x=>`<article class="build-item" data-build-item="${esc(x.id)}"><a class="build-item__media" href="${esc(x.url||'#')}">${x.image?`<img src="${esc(x.image)}" loading="lazy" alt="">`:''}</a><div class="build-item__copy"><span class="eyebrow">${esc(categoryFor(x))}</span><a href="${esc(x.url||'#')}"><h3>${esc(x.title)}</h3></a><strong>${money(x.price)}</strong><div><a class="btn" href="${esc(x.url||'#')}">View product</a><button class="text-button" type="button" data-build-remove="${esc(x.id)}">Remove</button></div></div></article>`).join('');
    const missing=['exterior','interior','performance','technology'].sort((a,b)=>c[a]-c[b]).slice(0,3);const links=document.querySelector('[data-build-next-links]');if(links)links.innerHTML=missing.map(k=>`<a class="build-next-card" href="/search?q=${encodeURIComponent(k)}&type=product"><span>${k}</span><strong>${c[k]?'Keep building':'Start here'} →</strong></a>`).join('');
    host.querySelectorAll('[data-build-remove]').forEach(b=>b.addEventListener('click',()=>{write(savedKey,read(savedKey,[]).filter(x=>String(x.id)!==String(b.dataset.buildRemove)));renderBuild();syncHeader()}));
  }
  document.querySelector('[data-clear-build]')?.addEventListener('click',()=>{if(confirm('Clear all saved parts from Your Build?')){write(savedKey,[]);renderBuild();syncHeader()}});
  window.addEventListener('storage',()=>{syncHeader();renderBuild()});syncHeader();renderBuild();
})();

// SETTE v8.4: exact-fitment assist, Garage shopping and installation guidance.
(() => {
  const key='sette_vehicle';
  const readVehicle=()=>{try{return JSON.parse(localStorage.getItem(key)||'null')}catch{return null}};
  const norm=s=>String(s||'').toLowerCase().replace(/[–—]/g,'-').replace(/[^a-z0-9]+/g,' ').trim();
  const label=v=>[v?.year,v?.make,v?.model,v?.generation,v?.body].filter(Boolean).join(' ');

  const updateGarageShop=()=>{
    const v=readVehicle();
    document.querySelectorAll('[data-garage-shop]').forEach(a=>{
      if(!v?.make){a.href='/collections/all';return}
      const q=[v.make,v.model,v.generation,v.year,v.body].filter(Boolean).join(' ');
      a.href=`/search?q=${encodeURIComponent(q)}&type=product`;
      a.textContent='Shop parts for my car';
    });
  };

  const product=document.querySelector('[data-product-root]');
  const applySavedFitment=()=>{
    if(!product)return;
    const v=readVehicle(); if(!v?.model)return;
    const groups=[...product.querySelectorAll('[data-option-index]')];
    let matched=0;
    const wanted=[v.model,v.generation,v.body].filter(Boolean).map(norm);
    groups.forEach((group,index)=>{
      const name=norm(group.dataset.optionName);
      const pills=[...group.querySelectorAll('.option-pill')];
      let target=null;
      if(/vehicle|fitment|model|generation/.test(name)) target=pills.find(p=>wanted.filter(Boolean).every((w,i)=>i>1||!w||norm(p.dataset.value).includes(w))) || pills.find(p=>norm(p.dataset.value).includes(norm(v.model)) && (!v.generation||norm(p.dataset.value).includes(norm(v.generation))));
      if(/body|door/.test(name)&&v.body) target=pills.find(p=>norm(p.dataset.value)===norm(v.body) || norm(p.dataset.value).includes(norm(v.body)));
      if(target&&!target.hidden&&!target.disabled){target.click();matched++}
    });
    const status=document.querySelector('[data-product-fitment-status]');
    if(status){status.hidden=false;status.className='fitment-status '+(matched?'is-match':'is-check');status.textContent=matched?`✓ ${label(v)}`:`Check fitment: ${label(v)}`}
  };

  const installation=()=>{
    const card=document.querySelector('[data-installation-card]');if(!card)return;
    const h=norm(card.dataset.productInstallation), level=card.querySelector('[data-installation-level]'), copy=card.querySelector('[data-installation-copy]');
    let l='Moderate installation',c='Fitment can vary by vehicle. Test-fit the part before final installation and use the supplied or appropriate automotive fixings.';
    if(/spoiler|badge|mirror cap|paddle|cushion|headrest/.test(h)){l='Easy–moderate installation';c='Typically installed with automotive adhesive, clips or simple fixings depending on the part. Careful surface preparation and alignment are important.'}
    if(/grille|steering wheel|ambient lighting|carplay/.test(h)){l='Professional installation recommended';c='This upgrade may require bumper, trim, airbag or electrical removal. Professional installation is recommended unless you are experienced with the work involved.'}
    if(/diffuser|side skirt|splitter|spat|canard|body kit/.test(h)){l='Moderate installation';c='Usually fitted using existing mounting areas, automotive adhesive and/or mechanical fixings. Some vehicles may require trim or bumper removal; professional fitting is recommended if you are unsure.'}
    level.textContent=l;copy.textContent=c;
  };

  updateGarageShop(); installation();
  setTimeout(applySavedFitment,120);
  document.addEventListener('sette:vehicle-updated',()=>{updateGarageShop();setTimeout(applySavedFitment,50)});
  window.addEventListener('storage',updateGarageShop);
})();


// SETTE v8.6: clean year-first fitment. Generation codes are display aids only;
// compatibility is decided by make + model + model year (+ body style where supplied).
(() => {
  const VEHICLE_KEY='sette_vehicle';
  const norm=s=>String(s||'').toLowerCase().replace(/[–—]/g,'-').replace(/[^a-z0-9+]+/g,' ').trim();
  const readVehicle=()=>{try{return JSON.parse(localStorage.getItem(VEHICLE_KEY)||'null')}catch{return null}};
  const writeVehicle=v=>localStorage.setItem(VEHICLE_KEY,JSON.stringify(v));
  const asYear=v=>{const n=parseInt(String(v||'').match(/(?:19|20)\d{2}/)?.[0]||'',10);return Number.isFinite(n)?n:null};

  // Customer-facing generation names. These are never used as the compatibility key.
  // Where Audi owners commonly use two names, show both (e.g. 8T/B8.5).
  const audiGeneration=(model,year)=>{
    const m=String(model||'').toUpperCase().replace(/\s+/g,''); const y=asYear(year); if(!y)return '';
    const inr=(a,b)=>y>=a&&y<=b;
    if(['A1'].includes(m)) return inr(2010,2017)?'8X':y>=2018?'GB':'';
    if(['S1'].includes(m)) return inr(2014,2018)?'8X':'';
    if(['A3'].includes(m)) return y<=2012?'8P':inr(2013,2016)?'8V':inr(2017,2020)?'8V Facelift':y>=2021?'8Y':'';
    if(['S3'].includes(m)) return y<=2012?'8P':inr(2013,2016)?'8V':inr(2017,2020)?'8V Facelift':y>=2021?'8Y':'';
    if(['RS3'].includes(m)) return y<=2013?'8P':inr(2015,2016)?'8V':inr(2017,2020)?'8V Facelift':y>=2021?'8Y':'';
    if(['A4','S4','RS4'].includes(m)) return y<=2011?'B8':inr(2012,2015)?'B8.5':inr(2016,2019)?'B9':inr(2020,2024)?'B9.5':y>=2025?'B10':'';
    if(['A5','S5'].includes(m)) return y<=2011?'8T/B8':inr(2012,2016)?'8T/B8.5':inr(2017,2019)?'B9':inr(2020,2024)?'B9.5':y>=2025?'B10':'';
    if(m==='RS5') return y<=2015?'8T/B8.5':inr(2017,2019)?'B9':inr(2020,2024)?'B9.5':'';
    if(['A6','S6','RS6'].includes(m)) return y<=2011?'C6':inr(2012,2014)?'C7':inr(2015,2018)?'C7.5':inr(2019,2022)?'C8':y>=2023?'C8 Facelift':'';
    if(['A7','S7','RS7'].includes(m)) return y<=2014?'C7':inr(2015,2018)?'C7.5':y>=2019?'C8':'';
    if(['A8','S8'].includes(m)) return y<=2013?'D4':inr(2014,2017)?'D4 Facelift':inr(2018,2021)?'D5':y>=2022?'D5 Facelift':'';
    if(['TT','TTS','TTRS','TTRS'].includes(m)) return y<=2014?'8J':inr(2015,2018)?'8S':y>=2019?'8S Facelift':'';
    return '';
  };

  const detectedGeneration=(make,model,year)=>norm(make)==='audi'?audiGeneration(model,year):'';

  // Finds year ranges such as 2012-16, 2012-2016, 2020-24 and 2020-Present.
  const yearRanges=text=>{
    const t=String(text||'').replace(/[–—]/g,'-'); const out=[];
    const re=/\b((?:19|20)\d{2})\s*-\s*(present|(?:19|20)?\d{2})\b/gi; let m;
    while((m=re.exec(t))){
      const start=parseInt(m[1],10); let end;
      if(/present/i.test(m[2])) end=9999;
      else { end=parseInt(m[2],10); if(end<100) end=Math.floor(start/100)*100+end; }
      out.push([start,end]);
    }
    // Single four-digit years are only considered if no explicit range was found.
    if(!out.length){ for(const hit of t.matchAll(/\b((?:19|20)\d{2})\b/g)){const y=parseInt(hit[1],10);out.push([y,y])} }
    return out;
  };
  const yearMatches=(text,year)=>{const y=asYear(year);if(!y)return true;const ranges=yearRanges(text);return !ranges.length?null:ranges.some(([a,b])=>y>=a&&y<=b)};

  const vehicleLabel=v=>[v?.year,v?.make,v?.model,v?.generation,v?.body].filter(Boolean).join(' ');
  const updateGenerationFields=form=>{
    if(!form)return; const make=form.elements.make?.value||'', model=form.elements.model?.value||'', year=form.elements.year?.value||'';
    const gen=detectedGeneration(make,model,year); const el=form.elements.generation;
    if(el && gen){el.value=gen; el.dataset.autoGeneration='true'}
    else if(el?.dataset.autoGeneration==='true'){el.value='';delete el.dataset.autoGeneration}
  };

  document.querySelectorAll('[data-vehicle-selector],[data-garage-form]').forEach(form=>{
    ['make','model','year'].forEach(k=>form.elements[k]?.addEventListener('input',()=>updateGenerationFields(form)));
    ['make','model','year'].forEach(k=>form.elements[k]?.addEventListener('change',()=>updateGenerationFields(form)));
    updateGenerationFields(form);
  });

  // Capture saves before older handlers: store the friendly generation alias, but search by year instead.
  document.querySelectorAll('[data-vehicle-selector],[data-garage-form]').forEach(form=>{
    form.addEventListener('submit',()=>{
      updateGenerationFields(form);
      const d=new FormData(form); const v={make:d.get('make')||'',model:d.get('model')||'',generation:d.get('generation')||'',year:d.get('year')||'',body:d.get('body')||''};
      if(v.make&&v.model) writeVehicle(v);
    },true);
  });

  // Search input: keep the customer's wording, but remove the four-digit year from Shopify's text query.
  // The year is carried separately and used as a hard compatibility filter in the browser.
  document.querySelectorAll('[data-sette-search-form]').forEach(form=>form.addEventListener('submit',e=>{
    const input=form.querySelector('input[name="q"]'); if(!input)return;
    const original=input.value.trim(); const ym=original.match(/\b((?:19|20)\d{2})\b/); if(!ym)return;
    e.preventDefault(); const year=ym[1]; const clean=original.replace(ym[0],' ').replace(/\s+/g,' ').trim();
    const u=new URL(form.action||location.pathname,location.origin);u.searchParams.set('q',clean);u.searchParams.set('type','product');u.searchParams.set('sette_year',year);location.href=u.pathname+'?'+u.searchParams.toString();
  }));

  // Vehicle selector searches never depend on generation nomenclature.
  document.querySelectorAll('[data-vehicle-selector]').forEach(form=>form.addEventListener('submit',e=>{
    e.preventDefault(); updateGenerationFields(form); const d=new FormData(form);
    const make=d.get('make')||'',model=d.get('model')||'',year=d.get('year')||'',body=d.get('body')||'',generation=d.get('generation')||'';
    const v={make,model,generation,year,body};writeVehicle(v);
    const q=[make,model,body].filter(Boolean).join(' '); const u=new URL('/search',location.origin);u.searchParams.set('q',q);u.searchParams.set('type','product');if(year)u.searchParams.set('sette_year',year);location.href=u.pathname+'?'+u.searchParams.toString();
  },true));

  // Garage "Shop parts" also uses make/model/year, never the generation code.
  const refreshGarageShop=()=>{
    const v=readVehicle();document.querySelectorAll('[data-garage-shop]').forEach(a=>{
      if(!v?.make){a.href='/collections/all';return}
      const q=[v.make,v.model,v.body].filter(Boolean).join(' ');const u=new URL('/search',location.origin);u.searchParams.set('q',q);u.searchParams.set('type','product');if(v.year)u.searchParams.set('sette_year',v.year);a.href=u.pathname+'?'+u.searchParams.toString();
    });
  };

  // Year-first result filtering. Universal rules still bypass vehicle-specific year restrictions.
  const filterSearchByYear=()=>{
    const host=document.querySelector('[data-fitment-search-results]');if(!host)return;
    const params=new URLSearchParams(location.search);const year=params.get('sette_year')||'';if(!asYear(year))return;
    let visible=0;
    host.querySelectorAll('[data-product-card]').forEach(card=>{
      const tags=(card.dataset.productTags||'').toLowerCase();
      const universal=tags.split('|').map(x=>x.trim()).includes('universal');
      const audiUniversal=tags.split('|').map(x=>x.trim()).includes('audi universal');
      const state=(universal||audiUniversal)?true:yearMatches(`${card.dataset.productTitle||''} ${card.dataset.productTags||''}`,year);
      // If a product has no year metadata, don't falsely exclude it; leave it for the customer to check.
      card.hidden=state===false;if(!card.hidden)visible++;
    });
    const old=document.querySelector('.search-empty');
    if(!visible && !old){const box=document.createElement('div');box.className='search-empty';box.innerHTML='<h2>No exact year matches found.</h2><p class="muted">Try a broader part name or contact Sette for a fitment check.</p>';host.after(box)}
  };

  // Override card confidence with year-first logic. Generation is deliberately ignored.
  const updateYearConfidence=()=>{
    const v=readVehicle();if(!v?.make)return;
    document.querySelectorAll('[data-product-card]').forEach(card=>{
      const badge=card.querySelector('[data-fitment-confidence]');if(!badge)return;
      const tags=(card.dataset.productTags||'').split('|').map(x=>norm(x)); const hay=norm(`${card.dataset.productTitle||''} ${card.dataset.productTags||''}`);
      const universal=tags.includes('universal') || (norm(v.make)==='audi'&&tags.includes('audi universal'));
      let state=null;
      if(universal) state=true;
      else if(v.make&&!hay.includes(norm(v.make))) state=false;
      else if(v.model&&!hay.includes(norm(v.model))) state=false;
      else {const ym=yearMatches(`${card.dataset.productTitle||''} ${card.dataset.productTags||''}`,v.year);state=ym===false?false:ym===true?true:null}
      badge.hidden=false;badge.classList.toggle('fitment-confidence--yes',state===true);badge.classList.toggle('fitment-confidence--no',state===false);badge.textContent=state===true?'Fits your car ✓':state===false?'Different vehicle':'Check fitment';
    });
  };

  // Auto-select product variants by model + year range. Generation is only a fallback if year metadata is absent.
  const selectYearFitment=()=>{
    const product=document.querySelector('[data-product-root]');const v=readVehicle();if(!product||!v?.model)return;
    let matched=0;
    product.querySelectorAll('[data-option-index]').forEach(group=>{
      const name=norm(group.dataset.optionName),pills=[...group.querySelectorAll('.option-pill')];let target=null;
      if(/vehicle|fitment|model|generation/.test(name)){
        const model=norm(v.model); const candidates=pills.filter(p=>norm(p.dataset.value).includes(model));
        target=candidates.find(p=>yearMatches(p.dataset.value,v.year)===true) || candidates.find(p=>v.generation&&norm(p.dataset.value).includes(norm(v.generation))) || candidates[0];
      }
      if(/body|door/.test(name)&&v.body) target=pills.find(p=>norm(p.dataset.value)===norm(v.body)||norm(p.dataset.value).includes(norm(v.body)))||target;
      if(target&&!target.hidden&&!target.disabled){target.click();matched++}
    });
    const status=document.querySelector('[data-product-fitment-status]');if(status){status.hidden=false;status.className='fitment-status '+(matched?'is-match':'is-check');status.textContent=matched?`✓ ${vehicleLabel(v)}`:`Check fitment: ${vehicleLabel(v)}`}
  };

  refreshGarageShop();filterSearchByYear();setTimeout(()=>{updateYearConfidence();selectYearFitment()},180);
  document.addEventListener('sette:vehicle-updated',()=>{refreshGarageShop();setTimeout(()=>{updateYearConfidence();selectYearFitment()},80)});
  window.addEventListener('storage',()=>{refreshGarageShop();updateYearConfidence()});
})();

// SETTE v8.7: Multi-car Garage. The active vehicle is mirrored to sette_vehicle
// so all existing year-first fitment logic remains compatible.
(() => {
  const GARAGE_KEY='sette_garage';
  const LEGACY_KEY='sette_vehicle';
  const panel=document.querySelector('[data-garage-panel]');
  const form=panel?.querySelector('[data-garage-form]');
  const listHost=panel?.querySelector('[data-garage-vehicles]');
  const toolbar=panel?.querySelector('[data-garage-toolbar]');
  const addBtn=panel?.querySelector('[data-garage-add]');
  const cancelBtn=panel?.querySelector('[data-garage-cancel]');
  if(!panel||!form||!listHost)return;

  const read=(key,fallback)=>{try{return JSON.parse(localStorage.getItem(key)||JSON.stringify(fallback))}catch{return fallback}};
  const write=(key,value)=>localStorage.setItem(key,JSON.stringify(value));
  const esc=s=>String(s||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  const uid=()=>`car_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,8)}`;
  const vehicleLabel=v=>[v?.year,v?.make,v?.model,v?.generation,v?.body].filter(Boolean).join(' ');
  const displayName=v=>v?.nickname?.trim()||[v?.year,v?.make,v?.model].filter(Boolean).join(' ')||'Vehicle';

  const blankGarage=()=>({version:1,activeId:null,vehicles:[]});
  function loadGarage(){
    let g=read(GARAGE_KEY,null);
    if(!g||!Array.isArray(g.vehicles)){
      g=blankGarage();
      const legacy=read(LEGACY_KEY,null);
      if(legacy?.make&&legacy?.model){
        const migrated={id:uid(),nickname:'',make:legacy.make||'',model:legacy.model||'',generation:legacy.generation||'',year:legacy.year||'',body:legacy.body||''};
        g.vehicles=[migrated];g.activeId=migrated.id;
      }
      write(GARAGE_KEY,g);
    }
    if(g.vehicles.length&&!g.vehicles.some(v=>v.id===g.activeId))g.activeId=g.vehicles[0].id;
    return g;
  }
  function activeVehicle(g=loadGarage()){return g.vehicles.find(v=>v.id===g.activeId)||null}
  function mirrorActive(g=loadGarage()){
    const active=activeVehicle(g);
    if(active)write(LEGACY_KEY,{make:active.make,model:active.model,generation:active.generation,year:active.year,body:active.body});
    else localStorage.removeItem(LEGACY_KEY);
    document.querySelectorAll('[data-garage-dot]').forEach(x=>x.hidden=!active);
    document.querySelectorAll('[data-garage-label],[data-build-car-label]').forEach(x=>x.textContent=active?vehicleLabel(active):'No car selected');
    return active;
  }
  function searchHref(v){
    if(!v?.make)return '/collections/all';
    const q=[v.make,v.model,v.body].filter(Boolean).join(' ');
    const u=new URL('/search',location.origin);u.searchParams.set('q',q);u.searchParams.set('type','product');if(v.year)u.searchParams.set('sette_year',v.year);return u.pathname+'?'+u.searchParams.toString();
  }
  function setFormMode(vehicle=null){
    if(vehicle){
      ['id','nickname','make','model','generation','year','body'].forEach(k=>{
        const name=k==='id'?'vehicle_id':k;const el=form.elements[name];if(el)el.value=vehicle[k]||'';
      });
      form.hidden=false;toolbar.hidden=false;cancelBtn.hidden=false;form.querySelector('[data-garage-save]').textContent='Save changes';
    }else{
      form.reset();if(form.elements.vehicle_id)form.elements.vehicle_id.value='';
      form.hidden=false;cancelBtn.hidden=loadGarage().vehicles.length===0;form.querySelector('[data-garage-save]').textContent='Save vehicle';
    }
    form.elements.nickname?.focus();
  }
  function render(){
    const g=loadGarage();const active=mirrorActive(g);
    toolbar.hidden=g.vehicles.length===0;
    listHost.innerHTML=g.vehicles.length?g.vehicles.map(v=>{
      const isActive=v.id===g.activeId;
      return `<article class="garage-vehicle${isActive?' is-active':''}" data-garage-vehicle="${esc(v.id)}">
        <div class="garage-vehicle__top"><div class="garage-vehicle__copy"><strong class="garage-vehicle__name">${esc(displayName(v))}</strong><span class="garage-vehicle__meta">${esc(vehicleLabel(v))}</span></div>${isActive?'<span class="garage-active-mark">Active</span>':''}</div>
        <div class="garage-vehicle__actions">
          ${isActive?`<a class="btn btn-primary" href="${esc(searchHref(v))}">Shop parts</a>`:`<button class="btn" type="button" data-garage-select="${esc(v.id)}">Select</button>`}
          <button class="btn" type="button" data-garage-edit="${esc(v.id)}">Edit</button>
          <button class="text-button" type="button" data-garage-remove="${esc(v.id)}">Remove</button>
        </div>
      </article>`;
    }).join(''):'<div class="garage-empty">No vehicles saved.</div>';
    if(g.vehicles.length && !form.elements.vehicle_id.value)form.hidden=true;
    if(!g.vehicles.length)form.hidden=false;
    document.querySelectorAll('[data-garage-shop]').forEach(a=>a.href=searchHref(active));
  }
  function activate(id){
    const g=loadGarage();if(!g.vehicles.some(v=>v.id===id))return;g.activeId=id;write(GARAGE_KEY,g);mirrorActive(g);render();document.dispatchEvent(new CustomEvent('sette:vehicle-updated',{detail:activeVehicle(g)}));
  }

  // Keep the panel in multi-car mode after the legacy Garage handler opens it.
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-garage-open]'))setTimeout(render,0);
    if(e.target.closest('[data-garage-add]')){e.preventDefault();setFormMode(null)}
    const select=e.target.closest('[data-garage-select]');if(select){e.preventDefault();activate(select.dataset.garageSelect)}
    const edit=e.target.closest('[data-garage-edit]');if(edit){e.preventDefault();const v=loadGarage().vehicles.find(x=>x.id===edit.dataset.garageEdit);if(v)setFormMode(v)}
    const remove=e.target.closest('[data-garage-remove]');if(remove){
      e.preventDefault();const g=loadGarage();const idx=g.vehicles.findIndex(x=>x.id===remove.dataset.garageRemove);if(idx<0)return;
      g.vehicles.splice(idx,1);if(g.activeId===remove.dataset.garageRemove)g.activeId=g.vehicles[0]?.id||null;write(GARAGE_KEY,g);form.reset();form.elements.vehicle_id.value='';mirrorActive(g);render();document.dispatchEvent(new CustomEvent('sette:vehicle-updated',{detail:activeVehicle(g)}));
    }
    if(e.target.closest('[data-garage-cancel]')){e.preventDefault();form.reset();form.elements.vehicle_id.value='';render()}
    if(e.target.closest('[data-clear-car]')){
      const g=loadGarage();if(g.activeId){g.vehicles=g.vehicles.filter(v=>v.id!==g.activeId);g.activeId=g.vehicles[0]?.id||null;write(GARAGE_KEY,g);mirrorActive(g);render();document.dispatchEvent(new CustomEvent('sette:vehicle-updated',{detail:activeVehicle(g)}));}
    }
  });

  // Runs after the legacy capture handler. The legacy key is intentionally overwritten by the active garage vehicle below.
  form.addEventListener('submit',e=>{
    e.preventDefault();e.stopImmediatePropagation();
    const d=new FormData(form);const g=loadGarage();const editing=String(d.get('vehicle_id')||'');
    const v={id:editing||uid(),nickname:String(d.get('nickname')||'').trim(),make:String(d.get('make')||'').trim(),model:String(d.get('model')||'').trim(),generation:String(d.get('generation')||'').trim(),year:String(d.get('year')||'').trim(),body:String(d.get('body')||'').trim()};
    if(!v.make||!v.model)return;
    const idx=g.vehicles.findIndex(x=>x.id===v.id);if(idx>=0)g.vehicles[idx]=v;else g.vehicles.push(v);g.activeId=v.id;write(GARAGE_KEY,g);form.reset();form.elements.vehicle_id.value='';mirrorActive(g);render();document.dispatchEvent(new CustomEvent('sette:vehicle-updated',{detail:v}));
  });

  // Vehicle selectors elsewhere on the storefront also add/select a Garage vehicle.
  document.querySelectorAll('[data-vehicle-selector]').forEach(selector=>selector.addEventListener('submit',()=>{
    const d=new FormData(selector);const make=String(d.get('make')||'').trim(),model=String(d.get('model')||'').trim();if(!make||!model)return;
    const candidate={nickname:'',make,model,generation:String(d.get('generation')||'').trim(),year:String(d.get('year')||'').trim(),body:String(d.get('body')||'').trim()};
    const g=loadGarage();const same=g.vehicles.find(v=>[v.make,v.model,v.year,v.body].map(x=>String(x||'').toLowerCase()).join('|')===[candidate.make,candidate.model,candidate.year,candidate.body].map(x=>String(x||'').toLowerCase()).join('|'));
    if(same){g.activeId=same.id;if(candidate.generation&&!same.generation)same.generation=candidate.generation;}else{candidate.id=uid();g.vehicles.push(candidate);g.activeId=candidate.id;}
    write(GARAGE_KEY,g);mirrorActive(g);
  },true));

  // If another tab changes the garage, keep this tab and the legacy fitment mirror aligned.
  window.addEventListener('storage',e=>{if(e.key===GARAGE_KEY){mirrorActive(loadGarage());render();document.dispatchEvent(new CustomEvent('sette:vehicle-updated',{detail:activeVehicle()}))}});
  render();
})();


// SETTE v8.7.1: vehicle-scoped builds, strict fitment search and vehicle collection filters.
(() => {
  const GARAGE_KEY='sette_garage';
  const VEHICLE_KEY='sette_vehicle';
  const LEGACY_BUILD_KEY='sette_saved_build';
  const BUILDS_KEY='sette_vehicle_builds';
  const read=(k,f)=>{try{return JSON.parse(localStorage.getItem(k)||JSON.stringify(f))}catch{return f}};
  const write=(k,v)=>localStorage.setItem(k,JSON.stringify(v));
  const esc=s=>String(s||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  const norm=s=>String(s||'').toLowerCase().replace(/[–—]/g,'-').replace(/[^a-z0-9]+/g,' ').trim();
  const money=p=>(Number(p||0)/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'GBP'});
  const categoryFor=item=>{const h=norm(`${item.type||''} ${item.title||''} ${item.tags||''}`);if(/splitter|diffuser|spoiler|wing|skirt|grille|canard|spat|badge|exterior/.test(h))return'exterior';if(/steering|paddle|trim|seat|cushion|mat|ambient|interior/.test(h))return'interior';if(/intake|exhaust|suspension|brake|turbo|intercooler|performance|engine|tune/.test(h))return'performance';if(/carplay|dashcam|charger|technology|tech|screen|audio|lighting/.test(h))return'technology';return'exterior'};
  const garage=()=>{const g=read(GARAGE_KEY,{activeId:null,vehicles:[]});return g&&Array.isArray(g.vehicles)?g:{activeId:null,vehicles:[]}};
  const activeVehicle=(g=garage())=>g.vehicles.find(v=>v.id===g.activeId)||null;
  const vehicleLabel=v=>[v?.year,v?.make,v?.model,v?.generation,v?.body].filter(Boolean).join(' ');
  const buildMap=()=>read(BUILDS_KEY,{});

  function ensureBuildMap(){
    const g=garage(),active=activeVehicle(g),hadMap=localStorage.getItem(BUILDS_KEY)!==null;let map=buildMap();
    if(!map||Array.isArray(map)||typeof map!=='object')map={};
    if(active && !(active.id in map)){
      // Only the first upgrade from v8.7 migrates the old single build. Newly added cars start empty.
      const legacy=hadMap?[]:read(LEGACY_BUILD_KEY,[]);
      map[active.id]=Array.isArray(legacy)?legacy:[];
      write(BUILDS_KEY,map);
    }
    return map;
  }
  function buildForActive(){const g=garage(),v=activeVehicle(g),map=ensureBuildMap();return v?(Array.isArray(map[v.id])?map[v.id]:[]):[]}
  function setBuildForActive(list){
    const g=garage(),v=activeVehicle(g);if(!v){write(LEGACY_BUILD_KEY,[]);return}
    const map=ensureBuildMap();map[v.id]=Array.isArray(list)?list:[];write(BUILDS_KEY,map);write(LEGACY_BUILD_KEY,map[v.id]);
  }
  function loadActiveBuild(){const list=buildForActive();write(LEGACY_BUILD_KEY,list);return list}
  function removeVehicleBuild(id){if(!id)return;const map=ensureBuildMap();delete map[id];write(BUILDS_KEY,map)}

  function counts(list){const c={exterior:0,interior:0,performance:0,technology:0};list.forEach(x=>c[categoryFor(x)]++);return c}
  function syncBuildChrome(list=buildForActive()){
    const v=activeVehicle();
    document.querySelectorAll('[data-build-total],[data-garage-build-count]').forEach(x=>x.textContent=list.length);
    document.querySelectorAll('[data-build-car-label]').forEach(x=>x.textContent=v?vehicleLabel(v):'No car selected');
  }
  function renderVehicleBuild(){
    const host=document.querySelector('[data-build-items]');const list=buildForActive();syncBuildChrome(list);if(!host)return;
    const empty=document.querySelector('[data-build-empty]'),next=document.querySelector('[data-build-next]'),c=counts(list),total=document.querySelector('[data-build-total-label]');
    if(total)total.textContent=`${list.length} part${list.length===1?'':'s'} saved`;
    ['exterior','interior','performance','technology'].forEach(k=>{document.querySelectorAll(`[data-build-page-count="${k}"]`).forEach(x=>x.textContent=c[k]);document.querySelectorAll(`[data-build-page-bar="${k}"]`).forEach(x=>x.style.width=`${Math.min(100,c[k]*20)}%`)});
    if(!list.length){host.innerHTML='';if(empty)empty.hidden=false;if(next)next.hidden=true;return}
    if(empty)empty.hidden=true;if(next)next.hidden=false;
    host.innerHTML=list.map(x=>`<article class="build-item" data-build-item="${esc(x.id)}"><a class="build-item__media" href="${esc(x.url||'#')}">${x.image?`<img src="${esc(x.image)}" loading="lazy" alt="${esc(x.title||'')}">`:''}</a><div class="build-item__copy"><span class="eyebrow">${esc(categoryFor(x))}</span><a href="${esc(x.url||'#')}"><h3>${esc(x.title)}</h3></a><strong>${money(x.price)}</strong><div><a class="btn" href="${esc(x.url||'#')}">View product</a><button class="text-button" type="button" data-v871-build-remove="${esc(x.id)}">Remove</button></div></div></article>`).join('');
    const missing=['exterior','interior','performance','technology'].sort((a,b)=>c[a]-c[b]).slice(0,3),links=document.querySelector('[data-build-next-links]');
    if(links)links.innerHTML=missing.map(k=>`<a class="build-next-card" href="/search?q=${encodeURIComponent(k)}&type=product"><span>${k}</span><strong>${c[k]?'Keep building':'Start here'} →</strong></a>`).join('');
  }

  // First v8.7.1 load migrates the old single build to the currently active car.
  ensureBuildMap();loadActiveBuild();setTimeout(renderVehicleBuild,0);

  // Saved parts always belong to the vehicle that is active at the time they are saved.
  document.querySelectorAll('[data-wishlist]').forEach(btn=>btn.addEventListener('click',()=>setTimeout(()=>{
    const legacy=read(LEGACY_BUILD_KEY,[]);setBuildForActive(Array.isArray(legacy)?legacy:[]);renderVehicleBuild();
  },120)));

  // Take ownership of build-page remove/clear actions so another car's build is never touched.
  document.addEventListener('click',e=>{
    const remove=e.target.closest('[data-v871-build-remove]');
    if(remove){e.preventDefault();e.stopImmediatePropagation();setBuildForActive(buildForActive().filter(x=>String(x.id)!==String(remove.dataset.v871BuildRemove)));renderVehicleBuild();return}
    const clear=e.target.closest('[data-clear-build]');
    if(clear){e.preventDefault();e.stopImmediatePropagation();if(confirm('Clear all saved parts from this build?')){setBuildForActive([]);renderVehicleBuild()}return}
    const garageRemove=e.target.closest('[data-garage-remove]');if(garageRemove)removeVehicleBuild(garageRemove.dataset.garageRemove);
    if(e.target.closest('[data-clear-car]')){const g=garage();if(g.activeId)removeVehicleBuild(g.activeId)}
  },true);

  // Switching, adding or editing a car swaps the build immediately.
  document.addEventListener('sette:vehicle-updated',()=>{loadActiveBuild();setTimeout(renderVehicleBuild,0)});
  window.addEventListener('storage',e=>{if(e.key===GARAGE_KEY||e.key===BUILDS_KEY){loadActiveBuild();renderVehicleBuild()}});

  // --- Search ---------------------------------------------------------------
  const supportedMakes=new Set(['audi','bmw']);
  const makeNames=['abarth','acura','alfa romeo','alpine','aston martin','audi','bentley','bmw','buick','cadillac','chevrolet','chrysler','citroen','citroën','cupra','dacia','dodge','ferrari','fiat','ford','genesis','gmc','honda','hyundai','infiniti','jaguar','jeep','kia','lamborghini','land rover','lexus','lincoln','lotus','maserati','mazda','mclaren','mercedes benz','mercedes-benz','mini','mitsubishi','nissan','opel','peugeot','polestar','porsche','ram','renault','rolls royce','saab','seat','skoda','škoda','smart','subaru','suzuki','tesla','toyota','vauxhall','volkswagen','volvo'];
  const audiModels=['ttrs','tt rs','tts','tt','rs3','rs4','rs5','rs6','rs7','s1','s3','s4','s5','s6','s7','s8','a1','a3','a4','a5','a6','a7','a8'];
  const bmwModels=['1 series','2 series','3 series','4 series','5 series','6 series','7 series','8 series','m2','m3','m4','m5','m6','m8','x1','x2','x3','x4','x5','x6','x7','xm','z4'];
  const bodyTerms=['3 door hatchback','5 door sportback','hatchback','sportback','sedan','coupe','wagon','suv'];
  const stop=new Set(['part','parts','for','the','a','an','and','car','cars','vehicle','vehicles','set','kit','kits']);
  function detectMake(text){const n=norm(text);return makeNames.find(m=>n.includes(norm(m)))||''}
  function detectModel(text,make=''){const n=norm(text),models=make==='bmw'?bmwModels:audiModels;return models.find(m=>new RegExp(`(^|\\s)${norm(m).replace(/ /g,'\\s+')}($|\\s)`).test(n))||''}
  function prettyModel(model){return model==='ttrs'||model==='tt rs'?'TT RS':model.replace(/\b\w/g,c=>c.toUpperCase())}
  function queryParts(original,make,model,year,body){
    let n=norm(original);[make,model,String(year||''),body].filter(Boolean).forEach(x=>{n=n.replace(new RegExp(`(^|\\s)${norm(x).replace(/ /g,'\\s+')}($|\\s)`,'g'),' ')});
    return n.split(/\s+/).filter(Boolean).filter(x=>!stop.has(x));
  }
  function internalVehicleQuery(make,model,partTerms=[]){
    const M=String(make||'').trim(),Mo=String(model||'').trim();
    if(!M||!Mo)return [M,Mo,...partTerms].filter(Boolean).join(' ');
    const universalBrand=`${M} Universal`;
    const group=`(\"${M} ${Mo}\" OR \"${Mo}\" OR \"${universalBrand}\" OR \"Universal\")`;
    return [group,...partTerms].join(' ').trim();
  }
  function goFitmentSearch({make,model,year='',body='',partTerms=[],display=''}){
    const u=new URL('/search',location.origin);const makeNorm=norm(make);
    if(!supportedMakes.has(makeNorm)){u.searchParams.set('q',[make,model,...partTerms].filter(Boolean).join(' '));u.searchParams.set('sette_unsupported','1')}
    else u.searchParams.set('q',internalVehicleQuery(make,model,partTerms));
    u.searchParams.set('type','product');u.searchParams.set('sette_vehicle_search','1');u.searchParams.set('sette_make',make);u.searchParams.set('sette_model',model);if(year)u.searchParams.set('sette_year',year);if(body)u.searchParams.set('sette_body',body);if(partTerms.length)u.searchParams.set('sette_part',partTerms.join(' '));if(display)u.searchParams.set('sette_display',display);location.href=u.pathname+'?'+u.searchParams.toString();
  }

  function saveSelectorVehicle(data){
    const make=String(data.get('make')||'').trim(),model=String(data.get('model')||'').trim();if(!make||!model)return null;
    const candidate={nickname:'',make,model,generation:String(data.get('generation')||'').trim(),year:String(data.get('year')||'').trim(),body:String(data.get('body')||'').trim()};
    const g=garage(),key=v=>[v.make,v.model,v.year,v.body].map(x=>norm(x)).join('|');let v=g.vehicles.find(x=>key(x)===key(candidate));
    if(v){if(candidate.generation&&!v.generation)v.generation=candidate.generation;g.activeId=v.id}
    else{v={...candidate,id:`car_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,8)}`};g.vehicles.push(v);g.activeId=v.id}
    write(GARAGE_KEY,g);write(VEHICLE_KEY,{make:v.make,model:v.model,generation:v.generation,year:v.year,body:v.body});
    const map=ensureBuildMap();if(!(v.id in map)){map[v.id]=[];write(BUILDS_KEY,map)}
    write(LEGACY_BUILD_KEY,map[v.id]||[]);return v;
  }

  // Override older form handlers before they can submit broad, ambiguous searches.
  document.addEventListener('submit',e=>{
    const form=e.target;
    if(form.matches('[data-vehicle-selector]')){
      e.preventDefault();e.stopImmediatePropagation();const d=new FormData(form),v=saveSelectorVehicle(d);if(!v)return;goFitmentSearch({make:v.make,model:v.model,year:v.year,body:v.body,display:[v.year,v.make,v.model,v.body].filter(Boolean).join(' ')});return;
    }
    if(form.matches('[data-collection-vehicle-filter]')){
      e.preventDefault();e.stopImmediatePropagation();const d=new FormData(form),make=String(d.get('make')||'').trim(),model=String(d.get('model')||'').trim(),year=String(d.get('year')||'').trim();if(!make||!model||!/^\d{4}$/.test(year))return;goFitmentSearch({make,model,year,display:[year,make,model].join(' ')});return;
    }
    if(form.matches('[data-sette-search-form]')){
      e.preventDefault();e.stopImmediatePropagation();const input=form.querySelector('input[name="q"]'),original=String(input?.value||'').trim();if(!original)return;
      const make=detectMake(original),year=(original.match(/\b(?:19|20)\d{2}\b/)||[])[0]||'',body=bodyTerms.find(b=>norm(original).includes(b))||'',model=make?detectModel(original,norm(make)):'';
      if(make&&model){const parts=queryParts(original,make,model,year,body);goFitmentSearch({make:make==='bmw'?'BMW':make.replace(/\b\w/g,c=>c.toUpperCase()),model:prettyModel(model),year,body,partTerms:parts,display:original});return}
      const u=new URL(form.action||'/search',location.origin);u.searchParams.set('q',original);u.searchParams.set('type','product');if(year)u.searchParams.set('sette_year',year);u.searchParams.set('sette_display',original);location.href=u.pathname+'?'+u.searchParams.toString();
    }
  },true);

  // Garage links use the same strict OR query, which brings Audi Universal products into Audi fitment results.
  function fitmentHref(v){
    if(!v?.make||!v?.model)return '/collections/all';const u=new URL('/search',location.origin),mn=norm(v.make);
    u.searchParams.set('q',supportedMakes.has(mn)?internalVehicleQuery(v.make,v.model):`${v.make} ${v.model}`);u.searchParams.set('type','product');u.searchParams.set('sette_vehicle_search','1');u.searchParams.set('sette_make',v.make);u.searchParams.set('sette_model',v.model);if(v.year)u.searchParams.set('sette_year',v.year);if(v.body)u.searchParams.set('sette_body',v.body);if(!supportedMakes.has(mn))u.searchParams.set('sette_unsupported','1');u.searchParams.set('sette_display',vehicleLabel(v));return u.pathname+'?'+u.searchParams.toString();
  }
  function refreshGarageLinks(){const v=activeVehicle();document.querySelectorAll('[data-garage-shop]').forEach(a=>a.href=fitmentHref(v));document.querySelectorAll('[data-garage-vehicle]').forEach(card=>{if(!card.classList.contains('is-active'))return;const link=card.querySelector('a.btn-primary');if(link)link.href=fitmentHref(v)})}
  setTimeout(refreshGarageLinks,0);document.addEventListener('sette:vehicle-updated',()=>setTimeout(refreshGarageLinks,0));

  function yearRanges(text){const t=String(text||'').replace(/[–—]/g,'-'),out=[];const re=/\b((?:19|20)\d{2})\s*-\s*(present|(?:19|20)?\d{2})\b/gi;let m;while((m=re.exec(t))){const start=parseInt(m[1],10);let end=/present/i.test(m[2])?9999:parseInt(m[2],10);if(end<100)end=Math.floor(start/100)*100+end;out.push([start,end])}return out}
  function yearMatch(text,year){const y=parseInt(year,10);if(!y)return true;const ranges=yearRanges(text);return !ranges.length?null:ranges.some(([a,b])=>y>=a&&y<=b)}
  function strictSearchResults(){
    const host=document.querySelector('[data-fitment-search-results]');if(!host)return;
    const p=new URLSearchParams(location.search),internal=p.get('q')||'',display=p.get('sette_display')||internal,make=p.get('sette_make')||detectMake(display),model=p.get('sette_model')||(make?prettyModel(detectModel(display,norm(make))):''),year=p.get('sette_year')||'',body=p.get('sette_body')||'',unsupported=p.get('sette_unsupported')==='1',vehicleSearch=p.get('sette_vehicle_search')==='1';
    const input=document.querySelector('[data-sette-search-form] input[name="q"]');if(input&&display)input.value=display;
    const partTerms=(p.get('sette_part')?norm(p.get('sette_part')).split(/\s+/):queryParts(display,make,model,year,body)).filter(Boolean);
    let visible=0;
    host.querySelectorAll('[data-product-card]').forEach(card=>{
      const title=card.dataset.productTitle||'',tagList=(card.dataset.productTags||'').split('|').map(x=>norm(x)).filter(Boolean),hay=norm(`${title} ${card.dataset.productTags||''}`),isUniversal=tagList.includes('universal'),isBrandUniversal=make&&tagList.includes(`${norm(make)} universal`);
      let ok=!unsupported;
      if(ok&&make){const sameMake=hay.includes(norm(make));ok=isUniversal||isBrandUniversal||sameMake}
      if(ok&&model&&!isUniversal&&!isBrandUniversal)ok=hay.includes(norm(model));
      if(ok&&year&&!isUniversal&&!isBrandUniversal){const ym=yearMatch(`${title} ${card.dataset.productTags||''}`,year);if(ym===false)ok=false}
      // Part words remain mandatory even for universal items: an Audi valve-cap search should not surface a cleaning kit.
      if(ok&&partTerms.length)ok=partTerms.every(t=>hay.includes(t));
      // A vehicle selected from the fitment UI must belong to a catalogue make we actually support.
      if(ok&&vehicleSearch&&make&&!supportedMakes.has(norm(make)))ok=false;
      card.hidden=!ok;if(ok)visible++;
    });
    const empty=document.querySelector('[data-search-empty]'),title=empty?.querySelector('[data-search-empty-title]'),pagination=document.querySelector('[data-search-pagination]');
    if(empty)empty.hidden=visible!==0;if(title&&visible===0)title.textContent=`“${display}” not found.`;if(pagination)pagination.hidden=visible===0;
  }
  strictSearchResults();
})();


/* SETTE v8.7.2 — contact form abuse controls. Customer-facing UI stays intentionally generic. */
(()=>{
  const forms=[...document.querySelectorAll('form.sette-protected-form')];
  if(!forms.length)return;
  const now=()=>Date.now();
  const safeStore={
    get(k){try{return localStorage.getItem(k)||''}catch(e){return''}},
    set(k,v){try{localStorage.setItem(k,v)}catch(e){}}
  };
  const compact=s=>String(s||'').trim().replace(/\s+/g,' ');
  const fingerprint=s=>{let h=2166136261;for(let i=0;i<s.length;i++){h^=s.charCodeAt(i);h=Math.imul(h,16777619)}return(h>>>0).toString(36)};
  const show=(form,msg)=>{const el=form.querySelector('[data-sette-form-status]');if(!el)return;el.textContent=msg;el.hidden=!msg;el.classList.toggle('is-error',Boolean(msg))};
  const looksAutomated=text=>{
    const t=compact(text);
    if(/([^\s])\1{12,}/i.test(t))return true;
    if(/\b(\w{2,})\b(?:\s+\1\b){7,}/i.test(t))return true;
    const urls=(t.match(/(?:https?:\/\/|www\.)/gi)||[]).length;
    return urls>4;
  };
  forms.forEach(form=>{
    form.dataset.setteOpenedAt=String(now());
    const submit=form.querySelector('button[type="submit"]');
    form.addEventListener('input',()=>show(form,''),{passive:true});
    form.addEventListener('submit',e=>{
      const trap=compact(form.querySelector('input[name="sette_website"]')?.value);
      const name=compact(form.querySelector('[name="contact[name]"]')?.value);
      const email=compact(form.querySelector('[name="contact[email]"]')?.value).toLowerCase();
      const body=compact(form.querySelector('[name="contact[body]"]')?.value);
      const age=now()-Number(form.dataset.setteOpenedAt||now());
      const payload=fingerprint([name,email,body].join('|'));
      const lastKey='sette_form_last_'+payload,last=Number(safeStore.get(lastKey)||0);
      let blocked=false;
      if(trap)blocked=true;
      if(age<1800)blocked=true;
      if(body.length<8||looksAutomated(body)||looksAutomated(name))blocked=true;
      if(last&&now()-last<60000)blocked=true;
      if(blocked){
        e.preventDefault();e.stopImmediatePropagation();
        show(form,'Please check your details and try again.');
        form.dataset.setteOpenedAt=String(now()-2000);
        return;
      }
      safeStore.set(lastKey,String(now()));
      if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true')}
    },true);
  });
})();
